<template>
  <div class="modal-credit">
    <button @click="modalBackButton" class="button-back">
      <div class="button-inner">{{ $t('modal.90') }}</div>
    </button>

    <div class="credit-title">
      <span class="gradient-green">PAGAMENTO PIX</span>
    </div>

    <!-- 1️⃣ Miktar Girişi -->
    <div v-if="!pixData" class="credit-step">
      <div class="credit-amount-input">
        <label>quantia</label>
        <input
          v-model="modalAmount"
          type="number"
          min="1"
          placeholder="10-9999"
          class="input-field"
        />
      </div>

      <div class="credit-button">
        <button
          @click="createPixPayment"
          class="button-deposit"
          :disabled="loading || !modalAmount"
        >
          <div class="button-inner">
            <span v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
            <span v-else>pagar</span>
          </div>
        </button>
      </div>
    </div>

    <!-- 2️⃣ QR Görüntüleme -->
    <div v-else class="credit-step qr-section">
      

      <!-- QR base64 -->
      <div class="qr-image" v-if="pixData.pixQR">
        <img :src="pixData.pixQR" alt="Pix QR Code" />

      </div>

      <!-- Kod alanı -->
      <div class="pix-code-container">
        <label>Cópia</label>
        <div class="pix-code-box">
          <input type="text" readonly :value="pixData.pixCode" ref="pixInput" />
          <button @click="copyPixCode" class="copy-btn">
            <i class="fas fa-copy"></i>
          </button>
        </div>
      </div>

      <div class="credit-button">
        <button @click="resetPix" class="button-deposit">
          <div class="button-inner">Nova Transação</div>

        </button>
      </div>
    </div>

    <div class="credit-info" v-if="!pixData">
      {{ $t('modal.93') || 'Assim que o pagamento for concluído, seu saldo será adicionado automaticamente.' }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'ModalCredit',
  data() {
    return {
      modalAmount: null,
      loading: false,
      pixData: null // { pixCode, pixQR, providerId }
    }
  },
  computed: {
    ...mapGetters(['authUser'])
  },
  methods: {
    ...mapActions(['notificationShow', 'modalsSetShow']),

    async createPixPayment() {
      if (!this.modalAmount || this.modalAmount <= 0) {
        this.notificationShow({ type: 'error', message: 'Lütfen geçerli bir miktar giriniz.' })
        return
      }

      this.loading = true

      try {
        const res = await axios.post('/payment/pix/create', {
          userId: this.authUser.user._id,
          amount: parseFloat(this.modalAmount)
        })

        if (res.data.success) {
          this.pixData = {
            pixCode: res.data.pixCode,
            pixQR: res.data.pixQR,
            providerId: res.data.providerId
          }

          this.notificationShow({ type: 'success', message: 'Pix kodu başarıyla oluşturuldu.' })
        } else {
          this.notificationShow({ type: 'error', message: res.data.error || 'Pix oluşturma başarısız.' })
        }
      } catch (err) {
        console.error(err)
        this.notificationShow({
          type: 'error',
          message: err.response?.data?.error || 'Pix oluşturma hatası.'
        })
      } finally {
        this.loading = false
      }
    },

    copyPixCode() {
      const input = this.$refs.pixInput
      input.select()
      document.execCommand('copy')
      this.notificationShow({ type: 'success', message: 'PIX kodu kopyalandı!' })
    },

    resetPix() {
      this.pixData = null
      this.modalAmount = null
    },

    modalBackButton() {
      this.modalsSetShow(null)
      setTimeout(() => {
        this.modalsSetShow('Cashier')
      }, 200)
    }
  }
}
</script>

<style scoped>
.modal-credit {
  width: 900px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px 30px 50px 30px;
  border-radius: 15px;
  background: var(--background)
    linear-gradient(255deg, #07263d 0%, #07243a 100%);
}

.button-back {
  height: 33px;
  position: absolute;
  top: 15px;
  left: 20px;
  z-index: 1;
}

.button-back .button-inner {
  padding: 0 12px;
  font-size: 14px;
  font-weight: 800;
  color: #75adc2;
  background-color: #1a4f63;
  clip-path: polygon(6px 0, calc(100% - 6px) 0, 100% 25%, 100% 75%, calc(100% - 6px) 100%, 6px 100%, 0 75%, 0 25%);
  transition: color 0.3s ease;
}
.button-back:hover .button-inner {
  color: #fff;
}

.credit-title {
  text-align: center;
  text-transform: uppercase;
  font-size: 32px;
  font-weight: 900;
  margin-bottom: 30px;
}

.credit-step {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.credit-amount-input {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.credit-amount-input label {
  color: #9bc7d4;
  font-weight: 700;
  margin-bottom: 10px;
}

.credit-amount-input input {
  width: 60%;
  height: 50px;
  border: none;
  outline: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #0f2539;
  padding: 0 15px;
  text-align: center;
  background-color: #ffffff;
}

.qr-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.qr-title {
  color: #9bc7d4;
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

.qr-image img {
  width: 220px;
  height: 220px;
  border-radius: 10px;
  margin-bottom: 20px;
  border: 2px solid #00ffb7;
}

.pix-code-container {
  width: 80%;
  margin-bottom: 20px;
}

.pix-code-box {
  display: flex;
  align-items: center;
  background-color: #0b3248;
  border-radius: 8px;
  padding: 5px 10px;
}

.pix-code-box input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
}

.copy-btn {
  background: #00ffb7;
  border: none;
  color: #000;
  padding: 5px 8px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}
.copy-btn:hover {
  background: #01e0a3;
}

.credit-button {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
}

.button-deposit {
  min-width: 165px;
  height: 48px;
  border: none;
  cursor: pointer;
}

.button-deposit .button-inner {
  background: var(--button1);
  color: #fff;
  font-weight: 800;
  font-size: 16px;
  padding: 0 20px;
  border-radius: 8px;
}

.credit-info {
  margin-top: 20px;
  color: #db7d48;
  text-align: center;
  font-size: 14px;
}

@media (max-width: 768px) {
  .modal-credit {
    width: 100%;
    max-width: 100%;
    padding: 20px 15px 30px 15px;
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    background: var(--background)
      linear-gradient(255deg, #07263d 0%, #07243a 100%);
    overflow-y: auto;
    max-height: 90vh;
  }

  .credit-title {
    font-size: 22px;
    margin-bottom: 15px;
  }

  .credit-amount-input input {
    width: 100%;
    height: 45px;
    font-size: 16px;
  }

  .qr-image img {
    width: 180px;
    height: 180px;
  }

  .pix-code-container {
    width: 100%;
  }

  .pix-code-box {
    flex-direction: column;
    gap: 8px;
    padding: 10px;
  }

  .pix-code-box input {
    font-size: 12px;
    width: 100%;
    text-align: center;
  }

  .copy-btn {
    width: 100%;
    text-align: center;
    padding: 8px;
    font-size: 14px;
  }

  .credit-button {
    margin-top: 10px;
  }

  .button-deposit {
    min-width: 100%;
    height: 45px;
  }

  .button-deposit .button-inner {
    font-size: 15px;
  }

  .button-back {
    top: 10px;
    left: 10px;
  }

  .credit-info {
    font-size: 12px;
    margin-top: 10px;
  }
}

</style>
